import React from 'react';
import Twobuilding from "./assets/twobuilding.svg";
import commercialicon from "./assets/commercialicon.svg";
import interioricon from "./assets/interioricon.svg";
import renovation from "./assets/Renovationimg.svg";

const WhatWeDo = () => {
  return (
    <section className="w-full flex justify-center px-4 sm:px-6 lg:px-8">
      
      {/* CONTAINER FIXED TO 1440px */}
      <div className="w-full max-w-[1440px] py-12 sm:py-14 md:py-16 font-epilogue">

        {/* HEADER */}
        <div className="text-center mb-10 sm:mb-12">
          <span className="inline-block px-4 py-1 rounded-full bg-gray-200 text-xs font-semibold uppercase tracking-wider text-gray-700 mb-3 sm:mb-4">
            Our Solutions
          </span>
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold text-gray-900 mb-4 sm:mb-6">
            What We Do
          </h2>
          <p className="max-w-xl md:max-w-2xl mx-auto text-gray-600 text-base sm:text-lg leading-relaxed">
            Delivering comprehensive construction solutions across residential, 
            commercial, and industrial sectors.
          </p>
        </div>

        {/* BENTO GRID */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 sm:gap-6 lg:gap-4">

          {/* BIG LEFT */}
          <div className="md:col-span-2 relative group overflow-hidden rounded-3xl h-[260px] sm:h-[300px] md:h-[340px] lg:h-[380px]">
            <img 
              src={Twobuilding} 
              alt="Residential Construction" 
              className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />
            <div className="absolute bottom-0 left-0 p-4 sm:p-6 md:p-8 text-white">
              <h3 className="text-xl sm:text-2xl font-bold mb-1 sm:mb-2">
                Residential Construction
              </h3>
              <p className="text-md md:text-lg sm:text-sm text-gray-200 max-w-md">
                From villas to apartments, we build homes that reflect your dreams.
              </p>
            </div>
          </div>

          {/* RIGHT TOP */}
          <div className="bg-[#f0e9dc] rounded-3xl p-5 sm:p-6 md:p-8 flex flex-col justify-center h-full">
            <div className="mb-4 sm:mb-6">
              <div className="w-10 h-10 sm:w-12 sm:h-12">
                <img 
                  src={commercialicon} 
                  alt="commercialicon" 
                  className="w-full h-full object-contain"
                />
              </div>
            </div>
            <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-2 sm:mb-4">
              Commercial Projects
            </h3>
            <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
              Offices, malls, and more — crafted with structural excellence.
            </p>
          </div>

          {/* LEFT BOTTOM SMALL */}
          <div className="bg-[#d8f3dc] rounded-3xl p-5 sm:p-6 md:p-8 flex flex-col justify-center h-full">
            <div className="mb-4 sm:mb-6">
              <div className="w-10 h-10 sm:w-12 sm:h-12">
                <img 
                  src={interioricon} 
                  alt="interioricon" 
                  className="w-full h-full object-contain"
                />
              </div>
            </div>
            <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-2 sm:mb-4">
              Interior Fit-outs
            </h3>
            <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
              Turn bare spaces into beautifully finished interiors with functional elegance.
            </p>
          </div>

          {/* BIG RIGHT */}
          <div className="md:col-span-2 relative group overflow-hidden rounded-3xl h-[260px] sm:h-[300px] md:h-[340px] lg:h-[380px]">
            <img 
              src={renovation} 
              alt="Renovation & Remodeling" 
              className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />
            <div className="absolute bottom-0 left-0 p-4 sm:p-6 md:p-8 text-white">
              <h3 className="text-xl sm:text-2xl font-bold mb-1 sm:mb-2">
                Renovation & Remodeling
              </h3>
              <p className="text-md md:text-lg sm:text-sm text-gray-200 max-w-md">
                From villas to apartments, we build homes that reflect your dreams.
              </p>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default WhatWeDo;